const last = require('lodash/last')
const sortBy = require('lodash/sortBy')
const { VAT_PER_MARKET, NIGERIAN_ZONES } = require('../constants')

module.exports = (countryOrZone) => {
  if (!countryOrZone) {
    throw new Error('Country code or zone is required')
  }

  let parsedCountry = countryOrZone
  // PSM fsids aren't in the format of `country:ng`, so we support passing Nigerian zones to function
  // TO return subsequent ng vat values
  if (NIGERIAN_ZONES.includes(parsedCountry)) {
    parsedCountry = 'ng'
  }
  const marketVats = VAT_PER_MARKET[parsedCountry]
  return last(sortBy(marketVats, 'date'))
}
